module.exports = __webpack_public_path__ + "img/user-placeholder.4788048f.png";